import store from '../../store'
import createAxios from './api'

const PATH = 'server'
const PATH_RSSP = '/rssp/v1/server'

export default {
  async ping() {
    const axios = await createAxios(false)
    await axios.get(`${PATH}/ping`)
  },

  async getCurrentTime() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/currentTime`)

    return resp.data
  },

  async getVersionInfo() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/version`)

    return resp.data
  },

  async getLicenseInfo() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/license`)

    return resp.data
  },

  async getRSSPVersionInfo() {
    const axios = await createAxios(false)
    const fullurl = store.state.remoteConfig.rsspApiUrl + PATH_RSSP + '/version'
    const resp = await axios.get(fullurl)

    return resp.data
  },

  async getMetrics() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/metrics`)

    return resp.data
  },

  async getOidcConfig(client) {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/oidcConfigs/${client}`)

    return resp.data
  },

  async getRemoteConfig() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/config`)
    return resp.data
  }
}
